@if (subscriblyUnavailable()) {
  <ly-callout class="m-2" type="warning" icon="warning">
    One of our outside services is having a bad day - channel management is
    temporarily unavailable.
  </ly-callout>
}
<div class="card">
  <div class="platform-list" [class.is-mobile]="isMobile()">
    @for (platform of socialPlatforms; track $index) {
      <div class="platform-item">
        <div class="platform-header">
          <div class="platform-name">
            <ly-icon [icon]="platform" [class]="platform" size="30px"></ly-icon>
            <div class="platform-more">
              <h4>{{ platform | channelName }}</h4>
              <a
                class="platform-help-article"
                [href]="
                  'https://doddly.tawk.help/article/trouble-connecting-' +
                  platform
                "
                target="_blank"
              >
                Trouble connecting?
              </a>
            </div>
          </div>
          @if (profile().emailVerified) {
            <button
              class="button icon indigo"
              (click)="autorizePlatform(platform, $index)"
              [disabled]="subscriblyUnavailable()"
            >
              <ly-icon [icon]="platform"></ly-icon>
              Connect...
            </button>
          } @else {
            <button
              lyConfirm
              [lyConfirmTitle]="'Verify Email'"
              [lyConfirmContent]="
                'Almost there! Check your inbox to confirm your email first.'
              "
              [lyConfirmBtnClasses]="'button indigo'"
              [lyConfirmBtnLabel]="'Ok, got it'"
              [lyConfirmDisabled]="subscriblyUnavailable()"
              class="button icon indigo"
              [disabled]="subscriblyUnavailable()"
            >
              <ly-icon [icon]="platform" />
              Connect...
            </button>
          }
        </div>
        @if (!subscriblyUnavailable()) {
          <div class="platform-channels">
            @for (channel of channels()[platform]; track $index) {
              <div class="channel" [class.expired]="isChannelExpired(channel)">
                <div class="channel-details">
                  <ly-channel-avatar [channel]="channel"></ly-channel-avatar>
                  <div class="channel-details-content">
                    <h5>{{ channel.subscriblyChannel?.name }}</h5>
                    @if (isChannelExpired(channel)) {
                      <button
                        class="button outlined indigo icon small"
                        (click)="autorizePlatform(platform, $index)"
                      >
                        <ly-icon icon="channels" size="16px" />
                        Reconnect
                      </button>
                    }
                  </div>
                </div>
                <div class="channel-action">
                  @if (isChannelConnected(channel)) {
                    <ly-icon
                      class="channel-refresh"
                      icon="refresh"
                      size="22px"
                      (click)="refreshChannel(channel)"
                      pTooltip="Refresh"
                      tooltipPosition="top"
                    />
                  }
                  <div
                    class="channel-status"
                    [class.expired]="isChannelExpired(channel)"
                  >
                    @if (
                      isChannelConnected(channel) && !isChannelExpired(channel)
                    ) {
                      <ly-icon icon="check" />
                      <p *ngIf="isChannelConnected(channel)">Connected</p>
                    }
                    @if (isChannelExpired(channel)) {
                      <ly-icon icon="warning" />
                      <p>Expired</p>
                    }
                  </div>
                  <ly-icon
                    class="channel-delete"
                    lyConfirm
                    [lyConfirmTitle]="'Delete Channel'"
                    [lyConfirmHasRejectBtn]="true"
                    (confirm)="deleteChannel(channel)"
                    [lyConfirmCalloutContent]="
                      'If you delete this channel - all posts for this channel will be permanently deleted!'
                    "
                    icon="delete"
                  ></ly-icon>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
